<ng-container *ngIf="translation && group">
  <div class="form-group row" [formGroup]="group">
    <div class="col-sm-12 col-md-6">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>{{ translation.FechaInicio }}</mat-label>
        <input
          matInput
          placeholder="{{ translation.PeriodoDeCompra }}"
          [formControlName]="dateStartControlName"
          [matDatepicker]="FechaInicio"
          [min]="minDate"
        />
        <mat-error *ngIf="group?.get(dateStartControlName).errors || group?.get(dateStartControlName).invalid">
          {{ getErrorMessage(dateStartControlName) }}
        </mat-error>
        <mat-datepicker-toggle
          matSuffix
          [for]="FechaInicio"
        ></mat-datepicker-toggle>
        <mat-datepicker #FechaInicio></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-sm-12 col-md-6">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>{{ translation.FechaFin }}</mat-label>
        <input
          matInput
          [formControlName]="dateEndControlName"
          [matDatepicker]="FechaFin"
          placeholder="{{ translation.FechaFin }}"
          [min]="minDate"
        />
        <mat-error *ngIf="group?.get(dateEndControlName).errors || group?.get(dateEndControlName).invalid">
          {{ getErrorMessage(dateEndControlName) }}
        </mat-error>
        <mat-datepicker-toggle
          matSuffix
          [for]="FechaFin"
        ></mat-datepicker-toggle>
        <mat-datepicker #FechaFin></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</ng-container>